import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { request } from "../request/request";

const initialState = {
    options: {},
    loadingStatus: {},
    error: {}
}

export const fetchFilterOptions = createAsyncThunk(
    "filterOptions/fetchFilterOptions",
    async ({ filterKey, url, token }, thunkApi) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                url,
                "GET",
                null,
                customHeaders
            )

            return {
                filterKey,
                options: response.data || []
            }
        } catch(error) {
            return thunkApi.rejectWithValue({
                filterKey,
                error: error.status || error.message
            })
        }
    }
);

const filterOptionsSlice = createSlice({
    name: "filterOptions",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFilterOptions.pending, (state, action) => {
                const { filterKey } = action.meta.arg;
                state.loadingStatus[filterKey] = "loading";
                state.error[filterKey] = null;
            })
            .addCase(fetchFilterOptions.fulfilled, (state, action) => {
                const { filterKey, options } = action.payload;
                state.options[filterKey] = options;
                state.loadingStatus[filterKey] = "idle";
                state.error[filterKey] = null;
            })
            .addCase(fetchFilterOptions.rejected, (state, action) => {
                const { filterKey } = action.payload || action.meta.arg;
                state.options[filterKey] = [];
                state.loadingStatus[filterKey] = "error";
                state.error[filterKey] = action.payload?.error || "Ошибка загрузки";
            })
    }
})

export default filterOptionsSlice.reducer;

